<hs-article-catalog
  #articleCatalog
  [dataSource]="articleCatalogDatasource.dataSource"
  [filterOptions]="filterOptions()"
  [showMoreButton]="true"
  [showAddBtn]="false"
  [showEditBtn]="true"
  [showDeleteBtn]="true"
  [withShoppingCart]="false"
  (editClicked)="onEditItemClicked($event)"
  (deleteClicked)="onDeleteItemClicked($event)"
  (input)="onArticleInputChanged()"
>
</hs-article-catalog>

<div class="flex flex-row w-full justify-end gap-2 p-2">
  <button
    hsButton
    hsButtonSize="sm"
    hsButtonVariant="outlined"
    (click)="dialogRef.close()"
  >
    {{ cancelLabel }}
  </button>
  <button
    hsButton
    hsButtonSize="sm"
    hsButtonVariant="filled"
    (click)="onSaveClicked()"
    [disabled]="!canSave()"
  >
    {{ okLabel }}
  </button>
</div>
